import React from 'react';

export default function OfflinePage() {
  return (
    <div className="container mx-auto py-16 px-4">
      <div className="max-w-md mx-auto text-center">
        <h1 className="text-2xl font-bold mb-4">You're Offline</h1>
        <p className="text-gray-600 mb-4">
          Please check your internet connection and try again.
        </p>
      </div>
    </div>
  );
}